import { Highlight } from "./types";

export const Ready = "document-viewer:ready";
export class ReadyEvent extends CustomEvent<number> {
  constructor() {
    super(Ready, {
      bubbles: false,
      cancelable: false,
    });
  }
}

export const ZoomChanged = "document-viewer:zoom-change";
export class ZoomChangedEvent extends CustomEvent<number> {
  constructor(scale: number) {
    super(ZoomChanged, {
      detail: scale,
      bubbles: false,
      cancelable: false,
    });
  }
}

export const HighlightNote = "document-viewer:highlight-note";
export type HighlightNoteDetail =
  | {
      action: "hide";
    }
  | {
      action: "show";
      highlight: Highlight;
      x: number;
      y: number;
    };
export class HighlightNoteEvent extends CustomEvent<HighlightNoteDetail> {
  constructor(detail: HighlightNoteDetail) {
    super(HighlightNote, {
      detail,
      bubbles: false,
      cancelable: false,
    });
  }
}

export const DocumentLoaded = "document-viewer:document-loaded";
export type DocumentLoadedDetail =
  | {
      documentType: "pdf";
      numberOfPages: number;
      fileName: string;
    }
  | {
      documentType: "image";
      fileName: string;
    };
export class DocumentLoadedEvent extends CustomEvent<DocumentLoadedDetail> {
  constructor(detail: DocumentLoadedDetail) {
    super(DocumentLoaded, {
      detail,
      bubbles: false,
      cancelable: false,
    });
  }
}

export const DocumentLoadFailed = "document-viewer:document-load-failed";
export type DocumentLoadFailedDetail = { error: string };
export class DocumentLoadFailedEvent extends CustomEvent<DocumentLoadFailedDetail> {
  constructor(detail: DocumentLoadFailedDetail) {
    super(DocumentLoadFailed, {
      detail,
      bubbles: false,
      cancelable: false,
    });
  }
}

export const DebugMessage = "document-viewer:debug-message";
export type DebugMessageDetail = { label: string; data: any };
export class DebugMessageEvent extends CustomEvent<DebugMessageDetail> {
  constructor(message: DebugMessageDetail) {
    super(DebugMessage, {
      detail: message,
      bubbles: false,
      cancelable: false,
    });
  }
}

export const AmplitudeTrack = "document-viewer:amplitude-track";
export class AmplitudeTrackEvent extends CustomEvent<{
  name: string;
  value?: Record<string, unknown>;
}> {
  constructor(name: string, value?: Record<string, unknown>) {
    super(AmplitudeTrack, {
      bubbles: false,
      cancelable: false,
      detail: {
        name,
        value,
      },
    });
  }
}

declare global {
  interface GlobalEventHandlersEventMap {
    [ZoomChanged]: ZoomChangedEvent;
    [HighlightNote]: HighlightNoteEvent;
    [DebugMessage]: DebugMessageEvent;
    [DocumentLoaded]: DocumentLoadedEvent;
    [DocumentLoadFailed]: DocumentLoadFailedEvent;
    [AmplitudeTrack]: AmplitudeTrackEvent;
  }
}
